<div class="box-center bg-yellow">
    <span>{{message}}</span>
</div>